export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-768w.c80df3aa.webp";